import { useForm } from "react-hook-form";

import { LegacyBuyerTableFilters } from "components/buyers/useLegacyFilterableBuyerTableState";
import { SelectBuyerList } from "components/form_components/BuyerListSelect";
import { BuyerSelect } from "components/form_components/BuyerSelect";
import { BuyerTypeSelect } from "components/form_components/BuyerTypeSelect";
import { CountryRegionSelect } from "components/form_components/CountryRegionSelect";
import { SignalSelect } from "components/form_components/SignalSelect";
import { useFormAutoSubmit } from "../../lib/hooks/useFormAutoSubmit";
import FilterFormTitle from "../filter_form/filter_form_title/FilterFormTitle";

import css from "./BuyerFilterForm.module.scss";

export type BuyerFilterSections =
  | "signals"
  | "buyerInformation"
  | "buyerLists"
  | "suppliers"
  | "buyerSearch";

export function BuyerFilterForm({
  filters,
  onFiltersChange,
  onClose,
  options,
}: {
  filters: LegacyBuyerTableFilters;
  onFiltersChange: (filters: LegacyBuyerTableFilters) => void;
  onClose: () => void;
  options?: {
    disabledFields?: keyof LegacyBuyerTableFilters[];
    disabledSections?: BuyerFilterSections[];
  };
}) {
  const { control, watch, trigger, getValues } = useForm<LegacyBuyerTableFilters>({
    mode: "onChange",
    defaultValues: filters,
  });

  useFormAutoSubmit({
    watch,
    getValues,
    trigger,
    onChange: onFiltersChange,
  });

  const disabledSections = options?.disabledSections || [];

  return (
    <>
      <FilterFormTitle onClose={onClose} />
      <form>
        <div className={css.formContent}>
          {!disabledSections.includes("signals") && (
            <>
              <h3 className={css.sectionTitle}>Signals</h3>
              <div className={css.filterSection}>
                <SignalSelect
                  name="signals"
                  label=""
                  control={control}
                  placeholder="Select..."
                  allowClear
                />
              </div>
            </>
          )}
          {!disabledSections.includes("buyerInformation") && (
            <>
              <h3 className={css.sectionTitle}>Buyer information</h3>
              <div className={css.filterSection}>
                {!disabledSections.includes("buyerSearch") && (
                  <BuyerSelect
                    name="buyerGuids"
                    label="Buyers"
                    control={control}
                    mode="multiple"
                    placeholder="Search buyers"
                    allowClear
                  />
                )}
                {!disabledSections.includes("buyerLists") && (
                  <SelectBuyerList
                    name="buyerLists"
                    label="Buyer lists"
                    control={control}
                    mode="multiple"
                    placeholder="Select"
                    allowClear
                  />
                )}
                <BuyerTypeSelect
                  label="Buyer type"
                  name="buyerTypes"
                  control={control}
                  multiple
                  placeholder="Select..."
                  allowClear
                />
                <CountryRegionSelect
                  name="hqCountry"
                  control={control}
                  label="Buyer location"
                  placeholder="Select..."
                  allowClear
                  aria-label="Buyer location filter"
                />
              </div>
            </>
          )}
        </div>
      </form>
    </>
  );
}
